/* Katana wind-cursor — drop-in, framework-free.
   Usage:
     <script src="katana-cursor.js"
             data-path=""          // folder holding the two PNGs (default: same as script)
             data-scale="0.28"      // cursor size
             data-sway="1"          // flick response
             data-wind="1"></script>
   Requires katana-sword.png + katana-tassel.png next to data-path. */
(function () {
  // Touch devices have no cursor to replace — skip entirely (saves 228KB of PNGs
  // + a permanent 60fps rAF loop) and bow out for reduced-motion users.
  if (!window.matchMedia ||
      !matchMedia('(hover: hover) and (pointer: fine)').matches ||
      matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var me = document.currentScript || (function () {
    var s = document.getElementsByTagName('script'); return s[s.length - 1];
  })();
  var d = me ? me.dataset : {};
  var S = parseFloat(d.scale) || 0.28;
  var SWAY = d.sway != null ? parseFloat(d.sway) : 1;
  var WIND = d.wind != null ? parseFloat(d.wind) : 1;
  var PATH = d.path != null ? d.path : (me ? me.src.replace(/[^\/]*$/, '') : '');

  // source image is 1672x941; geometry measured from it
  var TIP_X = 391, TIP_Y = 68;

  var style = document.createElement('style');
  style.textContent = 'html,body,*{cursor:none !important}';

  var wrap = document.createElement('div');
  wrap.style.cssText = 'position:fixed;top:0;left:0;z-index:99999;pointer-events:none;opacity:0;transition:opacity .25s ease;will-change:transform';

  var sword = document.createElement('img');
  sword.src = PATH + 'katana-sword.png'; sword.alt = ''; sword.draggable = false;
  sword.style.cssText = 'display:block;width:' + (1672 * S) + 'px;height:auto;filter:drop-shadow(0 14px 22px rgba(0,0,0,.55))';

  var tass = document.createElement('img');
  tass.src = PATH + 'katana-tassel.png'; tass.alt = ''; tass.draggable = false;
  tass.style.cssText = 'position:absolute;width:' + (84 * S) + 'px;height:auto;left:' + (1102 * S) + 'px;top:' + (706 * S) + 'px;transform-origin:' + (43 * S) + 'px ' + (-6 * S) + 'px;will-change:transform';

  wrap.appendChild(sword); wrap.appendChild(tass);

  function mount() {
    document.head.appendChild(style);
    document.body.appendChild(wrap);
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();

  function run() {
    var tipX = TIP_X * S, tipY = TIP_Y * S;
    var mx = innerWidth * 0.5, my = innerHeight * 0.5;
    var pmx = mx, pvx = 0, ang = 0, angVel = 0, shown = false, t = 0;

    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; wrap.style.opacity = '1'; }
    });
    document.addEventListener('mouseleave', function () { wrap.style.opacity = '0'; shown = false; });

    (function loop() {
      t += 1;
      wrap.style.transform = 'translate(' + (mx - tipX) + 'px,' + (my - tipY) + 'px)';
      var vx = mx - pmx, ax = vx - pvx;
      var drive = (-ax * 0.0048 - vx * 0.0010) * SWAY;
      var angAcc = -0.05 * ang - 0.115 * angVel + drive;
      angVel += angAcc; ang += angVel;
      if (ang > 1.15) { ang = 1.15; angVel *= -0.4; }
      if (ang < -1.15) { ang = -1.15; angVel *= -0.4; }

      var gust = 0.55 + 0.45 * Math.sin(t * 0.0055) * Math.sin(t * 0.0017 + 1.7);
      var wind = (Math.sin(t * 0.013) * 0.075 + Math.sin(t * 0.034 + 1.1) * 0.05 + Math.sin(t * 0.082 + 0.5) * 0.022) * gust * WIND - 0.05 * WIND;
      var skew = (Math.sin(t * 0.11) * 2.4 + Math.sin(t * 0.052 + 2.0) * 1.5) * gust * WIND;

      tass.style.transform = 'rotate(' + (ang + wind) + 'rad) skewX(' + skew + 'deg)';
      pmx = mx; pvx = vx;
      requestAnimationFrame(loop);
    })();
  }
})();
